import React from "react";
import { useLocation } from "react-router-dom";
import CloudSecurityCenter from "./cloud/CloudSecurityCenter.jsx";

const OciDashboard = () => {
  const { search } = useLocation();
  const legacyMode =
    new URLSearchParams(search).get("cloudDashboard") === "legacy";

  return (
    <CloudSecurityCenter
      initialProviderScope="oci"
      initialWorkspace={legacyMode ? "technical" : "executive"}
    />
  );
};

export default OciDashboard;
